<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4285 20C15.1359 20 14.8434 19.888 14.6205 19.6651L7.76348 12.8081C7.31663 12.3613 7.31663 11.639 7.76348 11.1922L14.6205 4.33514C15.0674 3.88829 15.7896 3.88829 16.2365 4.33514C16.6833 4.78199 16.6833 5.50426 16.2365 5.95111L10.1874 12.0001L16.2365 18.0492C16.6833 18.496 16.6833 19.2183 16.2365 19.6651C16.0136 19.888 15.7211 20 15.4285 20Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
